import {
  anInsightStatus,
  aTeamPage,
  mockInsightsFilterFieldQueryQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightsFilterFieldQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightStatuses: [anInsightStatus()],
          teams: aTeamPage(),
        },
      });
    }
  ),
];
